import React from 'react';
import { NavLink } from 'react-router-dom';

import styles from '@app/components/UI/Footer/FooterMenu/FooterMenu.module.scss';
import { footerMenu } from '@app/components/UI/Footer/FooterMenuLinks';
import AngleDownSVG from '@app/images/icons/AngleDownSVG';
import { FooterMenuItem } from '@app/objects/CustomMenuItem';

interface FooterMenuProps {
	isMobile?: boolean;
}

const FooterMenuColumn: React.FC<{ title: string }> = ({ title }) => {
	const [isOpen, setIsOpen] = React.useState(false);

	const toggleOpen = () => setIsOpen((prevState) => !prevState);

	return (
		<div className={styles.col}>
			<label
				className={styles.label}
				onClick={toggleOpen}
			>
				{title}
				<AngleDownSVG className={`${styles.carrot} ${isOpen ? styles.up : ''}`} />
			</label>
			<div className={`${styles.content} ${isOpen ? styles.open : ''}`}>
				{footerMenu[title].map((item: FooterMenuItem, index) => {
					if (item.name === 'Media Kit' || item.name === 'Join Our Team' || item.newTab) {
						return (
							<a
								key={index}
								href={item.path}
								className={styles.link}
								target="_blank"
								rel="noopener noreferrer"
							>
								{item.name}
							</a>
						);
					}

					return (
						<NavLink
							key={index}
							to={item.path}
							className={styles.link}
						>
							{item.name}
						</NavLink>
					);
				})}
			</div>
		</div>
	);
};

const FooterMenu: React.FC<FooterMenuProps> = ({ isMobile = false }) => {
	return (
		<div className={`${styles.menuWrap} ${isMobile ? styles.menuWrap__mobile : ''}`}>
			{Object.keys(footerMenu).map((title, index) => (
				<FooterMenuColumn title={title} key={index} />
			))}
		</div>
	);
};

export default FooterMenu;
